/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { Loader } from '@g17eco/atoms/loader';
import { RootState } from '../../../reducers';

const ActivationRequired = ({ title }: { title?: string }) => {

  const currentUserState = useSelector((state: RootState) => state.currentUser);

  if (!currentUserState.loaded) {
    return <Loader />;
  }

  const user = currentUserState.data;
  return (
    <div className='row'>
      <div className='col-12 offset-md-2 col-md-8'>
        <h1 className={'text-ThemeAccentExtradark'}>{title ?? 'Onboarding Successful'}</h1>
        <h2 className='mb-4 text-ThemeTextDark'>What happens next?</h2>
        <p>An e-mail has been sent to <strong className='dont_translate'>{user.email}</strong>. Please click on the activation button in the e-mail to complete your registration.</p>
      </div>
    </div>
  );
};
export default ActivationRequired;
